import { apiCall, API_ENDPOINTS } from '../config/api';
import { getToken as _getToken, setToken as _setToken, clearToken as _clearToken } from '../utils/tokenStore';
import logger from '../utils/logger';

export function getToken() {
  return _getToken();
}

export function setToken(token) {
  _setToken(token);
}

export function clearToken() {
  _clearToken();
}

export async function login(username, password) {
  const response = await apiCall(API_ENDPOINTS.LOGIN, {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const err = data.error || `Login failed (status: ${response.status})`;
    throw new Error(err);
  }

  const data = await response.json();
  if (data.access_token) {
    _setToken(data.access_token);
  }
  return data.user;
}

export async function verify(timeout = 5000) {
  const response = await apiCall(API_ENDPOINTS.VERIFY, { timeout });
  if (!response.ok) {
    throw new Error(`Verify failed (status: ${response.status})`);
  }
  const data = await response.json();
  return data.user;
}

export async function refresh() {
  const response = await apiCall(API_ENDPOINTS.REFRESH, {
    method: 'POST',
    credentials: 'include',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });

  if (!response.ok) {
    throw new Error(`Refresh failed (status: ${response.status})`);
  }

  const data = await response.json();
  if (data.access_token) {
    _setToken(data.access_token);
  }
  return data.user;
}

export async function logout() {
  try {
    await apiCall(API_ENDPOINTS.LOGOUT, { method: 'POST' });
  } catch (err) {
    logger.warn('Logout server call failed:', err);
  } finally {
    _clearToken();
  }
}

export default { getToken, setToken, clearToken, login, verify, refresh, logout };
